<template>
	<div id="app">
		<div v-if="state == 'loading'">
			<div class="main-loading">
				<i class="fa fa-circle-notch fa-spin"></i>
			</div>
		</div>
		<div v-if="state == 'login'">
			<LoginForm @logged="checkUserAuth" @next="nextToForgotPassword" />
		</div>
		<div v-if="state == 'forgot-password'">
			<ForgotPassword 
				:email="email"
				@back="backToLogin" 
			/>
		</div>
		<div v-if="state == 'new-password'">
			<NewPassword 
				:email="email"
				:code="code"
				:identifier="identifier"
				@back="backToLogin"
			/>
		</div>
		<div v-if="state == 'authenticated'">
			<div class="menu-content">
				<MenuAdmin v-if="$api.user.sysadmin" ref="Menu" />
				<Menu v-if="!$api.user.sysadmin" ref="Menu" />
			</div>
			<div class="content">
				<router-view/>
			</div>
		</div>
		<tooltip />
		<Alert />
		<Notification />
	</div>
</template>

<script>
require('flexboxgrid');
import Api from "@/lib/Api";

import Alert from "@/components/Alert";
import Notification from "@/components/Notification";
import Menu from "@/components/Menu";
import MenuAdmin from "@/components/MenuAdmin";
import LoginForm from "@/views/LoginForm";
import ForgotPassword from "./views/ForgotPassword.vue";
import NewPassword from "./views/NewPassword.vue";

export default {
	name: "App",

	components: {
    Menu,
    LoginForm,
    Alert,
    Notification,
    MenuAdmin,
    ForgotPassword,
    NewPassword,
},

	data: function() {
		return {
			state: "loading",
		}
	},

	mounted: function() {
		console.log("versão: " + this.$api.config.B2B_VERSION);
		this.checkUserAuth();
	},

	methods: {
		checkUserAuth: async function() {
			// Verifica se tem sessão
			let auth = null;
            try {
                auth = await Api.get("auth/authenticated");
			} catch(ex) {
				console.log(ex);
			}

			// Verifica se foi retornado
			if (auth) {
				// Verifica o resultado da requisição
				if(auth.error) {
					// Testa o login para admin
					this.checkAdminAuth();
				} else {
					// Atualiza as informações
					this.$api.user = auth.data;
					this.state = "authenticated";

					// Verifica se é não é admin para decodificar as permissões
					if (!this.$api.user.is_admin)
						this.$api.user.permissions = JSON.parse(this.$api.user.permissions);

					this.$permission.setData(this.$api.user.is_admin, this.$api.user.permissions);

					// Redireciona para o roteiro caso seja externo
					if (this.$api.user.origin == "external") {
						if (this.$permission.hasAreaPermission("DeliveryRouting") && this.$api.user.company_routing) {
							if (this.$router.history.current.name != "Routing")
								this.$router.push({ name: 'Routing'});
						} else 
							this.$router.push({ name: 'Home'});
					} else {
						// Redireciona para o início
						if (this.$router.history.current.name != "Home")
							this.$router.push({ name: 'Home'});
					}
					
					// Espera o próximo ciclo
					/*this.$nextTick(() => {
						this.$refs.Menu.load_profile();
					});*/
				}
			} else {
				// Testa o login para admin
				this.checkAdminAuth();
			}
		},

		checkAdminAuth: async function() {
			// Verifica se tem sessão
			let auth = null;
            try {
                auth = await Api.get("auth/authenticated", "admin");
			} catch(ex) {
				console.log(ex);
			}
			
			// Verifica se foi retornado
			if (auth) {
				// Verifica o resultado da requisição
				if(auth.error) {
					this.checkGetParameters();
				} else {
					this.$api.user = auth.data;
					this.state = "authenticated";
					// Redireciona para o início
					if (this.$router.history.current.name != "Home") this.$router.push({ name: 'Home'});
					return;
				}
			} else {
				this.checkGetParameters();
			}
		},

		checkGetParameters: function() {
			let query = this.$route.query;
			if (((typeof query.action !== "undefined") && (query.action == "new-password")) && ((typeof query.code !== "undefined") && (query.code != "")) && ((typeof query.identifier !== "undefined") && (query.identifier != "")) && ((typeof query.email !== "undefined") && (query.email != ""))) {
				this.code = query.code;
				this.identifier = query.identifier;
				this.email = query.email;
				this.state = "new-password";
			} else {
				this.state = "login";
			}
			return;
		},

		nextToForgotPassword: function(email) {
			this.email = email;
			this.state = "forgot-password";
		},

		backToLogin: function() {
			this.state = "login";
		},
	}
}
</script>

<style>
body {
	background: #f5f5f5;
	margin: 0;
	padding: 0;
}

body, body * {
	font-family: Roboto, Helvetica, Arial, sans-serif;
	box-sizing: border-box;
	outline: none;
}



img {
	-webkit-touch-callout: none;
	/* iOS Safari */
	-webkit-user-select: none;
	/* Safari */
	-khtml-user-select: none;
	/* Konqueror HTML */
	-moz-user-select: none;
	/* Old versions of Firefox */
	-ms-user-select: none;
	/* Internet Explorer/Edge */
	user-select: none;
	/* Non-prefixed version, currently
		supported by Chrome, Opera and Firefox */
}

/* width */
::-webkit-scrollbar {
	width: 6px;
	height: 6px;
}

/* Track */
::-webkit-scrollbar-track {
	background: #cbcbcb;
}

/* Handle */
::-webkit-scrollbar-thumb {
	background: #9e9a9a;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
	background: #808080;
}




#app {
	font-family: Roboto, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #2c3e50;
}

.main-loading {
	font-size: 80px;
	color: #ddd;
	height: 100vh;
	line-height: 100vh;
	text-align: center;
}




.menu-content {
	float: left;
	width: 285px;
	height: 100vh;
	background: #fff;
	overflow: auto;
	/*border-right: 15px solid #f5f5f5;*/
}


.content {
	float: left;
	width: calc(100% - 285px);
	height: 100vh;
	overflow: auto;
	background: #f5f5f5;
	padding: 0px 15px 15px;
}


/*.inner-content {
	width: calc(100% - 15px);
	padding: 15px 0;
}*/


.inner-content-title {
	width: 100%;
	height: 60px;
	line-height: 60px;
	padding: 5px 15px;
	background: #fff;
	font-weight: bold;
	/*border: 1px solid #f0f0f0;*/
	border-radius: 4px 4px 0 0;
}



button, a {
	cursor: pointer;
}

button:active, button:hover, a:active, a:hover {
	opacity: 0.8;
}

button:disabled {
	cursor: default;
}


.shadowed {
    box-shadow: 0 0 0 0 transparent,0 0 0 0 transparent,0 4px 6px -1px rgba(0,0,0,.1),0 2px 4px -1px rgba(0,0,0,.06) !important;
}



.view-title {
	position: relative;
	text-align: left;
	padding: 15px 0;
	margin-bottom: 15px;
	border-bottom: 1px solid #ccc;
	font-size: 22px;
}

/*.view-title:before {
	background-image: url('assets/logo/New_DeliveryB2B__Cinza_Horizontal.png');
	background-size: cover;
	content: '';
	position: absolute;
	right: 25px;
	top: 18px;
	display: block;
	height: 22px;
	width: 230px;
}*/



.button-create {
	margin-left: 15px;
	width: 120px;
	height: 40px;
	border: none;
	background: #222;
	color: #fff;
	font-weight: bold;
}

.button-edit {
	border: none;
	background: #222;
	color: #fff;
	font-size: 10px;
	padding: 8px;
	margin-right: 5px;
}

.button-remove {
	border: none;
	background: red;
	color: #fff;
	font-size: 10px;
	padding: 8px;
	margin-right: 5px;
}

.button-create:disabled, .button-edit:disabled, .button-remove:disabled {
	cursor: not-allowed;
	opacity: 0.4;
}

.pull-right {
	float: right;
}



.list-unstyled {
	padding: 0 0 0 15px;
	margin: 0;
}

.marker-label {
	text-shadow: -2px 0px 0px #fff, 2px 0px 0px #fff, 0px -2px 0px #fff, 0px 2px 0px #fff !important;
}

.capitalized {
	text-transform: capitalize;
}

.pointer {
	cursor: pointer;
}

.popup {
    font-size: 10px;
}

.popup > p.marker {
    margin: 0px;
}

.popup > h3 {
    margin-block-start: 0px;
    margin-block-end: 10px;
}

.popup > h4 {
    margin-block-start: 0px;
    margin-block-end: 10px;
}

.input-tooltip {
	display: inline;
	position: relative;
	float: left;
	text-align: center;
	height: 90px;
	line-height: 80px;
	width: 20px;
	margin-bottom: 10px;
	cursor: pointer;
	color: #666;
}

div[data-popover='tooltip'] {
  background: #444;
  color: #f9f9f9;
  font-size: 13px;
  text-align: center;
  z-index: 4 !important;
}

.btn {
	border: none;
	padding: 10px 15px;
	font-weight: bold;
	font-size: 12px;
}

a.btn {
	text-decoration: none;
}

.btn-link {
	background: #d9d9d9;
	color: #595959;
}

.btn-right {
	float: right;
}

.vue-swatches,
.vue-swatches__trigger__wrapper {
	width: 100%;
}

.vue-swatches__trigger {
	width: 100% !important;
	height: 10px !important;
	border: 1px solid #fff !important;
	border-radius: 0px !important;
	box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12) !important;
}
</style>
